import React from 'react';
import Skeleton from 'react-skeleton-loader';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
const useStyles = makeStyles(theme => ({
  wrapper: {
    width: '350px',
    height: '500px'
  },
  headerWrapper: {
    marginTop: '20px',
    marginLeft: '10px'
  },
  skeletonWrapper: {
    width: '235%',
    height: '30px',
    marginLeft: '10px',
    marginTop: '20px',
    textAlign: 'initial',
  },
})
)
export default function CardListingLoader(props) {
  const classes = useStyles();
  return(
    <div className={classes.wrapper}>
      <div className={classes.skeletonWrapper}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Skeleton widthRandomness={0} height="70px" width="800px" color="#e0e0e0" />
          </Grid>
          <Grid item xs={12}>
            <Skeleton widthRandomness={0} height="100px" width="800px" color="#e0e0e0" />
          </Grid>
          <Grid item xs={3}>
            <Skeleton widthRandomness={0} count={7} height="25px" width="200px" color="#e0e0e0" />
          </Grid>
          <Grid item xs={6}>
            <Skeleton widthRandomness={0} count={7} height="25px" width="400px" color="#e0e0e0" />
          </Grid>
        </Grid>
      </div>
    </div>
  )
}
